module.exports = __webpack_public_path__ + "static/img/Daine-Laurie.1a0d21a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Daine-Laurie.jpg
// module id = /17x
// module chunks = 0